"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Base64Service = void 0;
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var Base64Service = /** @class */ (function () {
    function Base64Service() {
    }
    /**
     * Copied from web-full-bundle-assets/src/core/utility/common.service.js
     * https://github.com/seismic/web-full-bundle-assets/blob/b336218c50e4d97ce0543cc076c64037b3ef8687/src/core/utility/common.service.js#L189
     * @param value
     * @returns
     */
    Base64Service.prototype.decodeIfBase64 = function (value) {
        if (value === '' || value.trim() === '') {
            return value;
        }
        try {
            if (this.toBase64URL(this.fromBase64URL(value)) === value) {
                return this.fromBase64URL(value);
            }
            return this.safeDecodeURIComponent(value);
        }
        catch (err) {
            return this.safeDecodeURIComponent(value);
        }
    };
    /**
     * Copied from web-search-assets/src/utility/apiServiceHelper.js
     * https://github.com/seismic/web-search-assets/blob/72679e330e795ffeabc51af31196618be170852d/src/utility/apiServiceHelper.js#L33
     * @param str
     * @returns
     */
    Base64Service.prototype.isBase64URL = function (str) {
        if (str === '' || str.trim() === '') {
            return false;
        }
        try {
            return this.toBase64URL(this.fromBase64URL(str)) === str;
        }
        catch (err) {
            return false;
        }
    };
    /**
     * Copied from web-full-bundle-assets/src/core/utility/common.service.js
     * https://github.com/seismic/web-full-bundle-assets/blob/b336218c50e4d97ce0543cc076c64037b3ef8687/src/core/utility/common.service.js#L1551
     * @param value
     * @returns
     */
    Base64Service.prototype.toBase64URL = function (originString) {
        return btoa(encodeURIComponent(originString)).replace(/\//g, '_').replace(/\+/g, '-');
    };
    /**
     * Copied from web-full-bundle-assets/src/core/utility/common.service.js
     * https://github.com/seismic/web-full-bundle-assets/blob/b336218c50e4d97ce0543cc076c64037b3ef8687/src/core/utility/common.service.js#L1555
     * @param value
     * @returns
     */
    Base64Service.prototype.fromBase64URL = function (base64URL) {
        return this.safeDecodeURIComponent(atob(base64URL.replace(/_/g, '/').replace(/-/g, '+')));
    };
    Base64Service.prototype.safeDecodeURIComponent = function (text) {
        try {
            return window.decodeURIComponent(text);
        }
        catch (error) {
            console.warn('Error decode text:', text, error);
            return text;
        }
    };
    Base64Service = __decorate([
        CommonService_decorator_1.CommonService('Base64Service')
    ], Base64Service);
    return Base64Service;
}());
exports.Base64Service = Base64Service;
//# sourceMappingURL=Base64.service.js.map